<template>
  <div style="background-color: #e6f3ff">
    <v-container fluid>
      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-sheet elevation="12" class="pa-12">
            <v-form ref="form" @submit.prevent="postData">
              <v-row justify="center">
                <h1>ลงทะเบียน</h1>
              </v-row>
              <v-col class="pl-0 pr-0"> <v-divider></v-divider> </v-col
              >คำนำหน้าชื่อ
              <v-col cols="12" sm="12" class="pa-0">
                <v-radio-group
                  class="pa-0"
                  v-model="radio"
                  row
                  :rules="prefixRules"
                >
                  <v-radio label="นาย" value="mr"></v-radio>
                  <v-radio label="นาง" value="mrs"></v-radio>
                  <v-radio label="นางสาว" value="miss"></v-radio>
                  <v-radio label="อื่นๆ(ระบุ)" value="etc"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" sm="12" class="pa-0">
                <v-text-field
                  v-if="radio == 'etc'"
                  v-model="etc_title"
                  single-line
                  placeholder="ระบุคำนำหน้าชื่อ"
                  outlined
                  class="py-0 my-0"
                  :rules="rule_etc"
                ></v-text-field>
              </v-col>
              <div>ชื่อ</div>
              <v-text-field
                v-model="firstname"
                outlined
                solo
                :rules="nameRules"
              ></v-text-field>
              <div>นามสกุล</div>
              <v-text-field
                v-model="lastname"
                outlined
                solo
                :rules="lnameRules"
              ></v-text-field>

              <div>อีเมล</div>
              <v-text-field
                v-model="email"
                outlined
                solo
                :rules="emailRules"
              ></v-text-field>
              <div>ชื่อผู้ใช้</div>
              <v-text-field
                v-model="username"
                outlined
                solo
                :rules="userRules"
              ></v-text-field>
              <div>รหัสผ่าน</div>
              <v-text-field
                v-model="password"
                outlined
                solo
                :rules="passwordRules"
                type="password"
              ></v-text-field>
              <div>ยืนยันรหัสผ่าน</div>
              <v-text-field
                v-model="cfpassword"
                outlined
                solo
                :rules="cfpasswordRules"
                type="password"
              ></v-text-field>
              <v-btn block color="primary" type="submit">ลงทะเบียน</v-btn>
            </v-form>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      etc_title: "",
      firstname: "",
      lastname: "",
      permission: "",
      username: "",
      password: "",
      cfpassword: "",
      email: "",
      radio: "mr",
      headers: {
        "X-Csrf-Token": "xxxx",
      },
      header_token: {
        headers: { Authorization: "Bearer " + this.$session.get("token") },
      },
      prefixRules: [(v) => !!v || "* กรุณาเลือกคำนำหน้าชื่อ"],
      rule_etc: [
        (v) => !!v || "กรุณากรอกคำนำหน้าชื่อ",
        (v) =>
          /^([a-zA-Zก-๏ .])+$/.test(v) ||
          "* กรุณากรอกข้อมูลเป็นอักษรภาษาไทยหรือภาษาอังกฤษเท่านั้น",
        (v) => !/ /.test(v) || "* ห้ามมีช่องว่าง",

        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      nameRules: [
        (v) => !!v || "* กรุณากรอกชื่อ",
        (v) =>
          /^([a-zA-Zก-๏ ])+$/.test(v) ||
          "* กรุณากรอกข้อมูลเป็นอักษรภาษาไทยหรือภาษาอังกฤษเท่านั้น",
        (v) => v.length < 50 || "*ข้อมูลมีความยาวมากเกินไป",
        (v) => v.length >= 2 || "* กรุณากรอกชื่ออย่างน้อย 2 ตัวอักษร",
        (v) => /^\S+(\s\S+)*$/.test(v) || "* กรุณากรอกข้อมูลให้ถูกต้อง",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      lnameRules: [
        (v) => !!v || "* กรุณากรอกนามสกุล",
        (v) =>
          /^([a-zA-Zก-๏ ])+$/.test(v) ||
          "* กรุณากรอกข้อมูลเป็นอักษรภาษาไทยหรือภาษาอังกฤษเท่านั้น",
        (v) => v.length < 50 || "*ข้อมูลมีความยาวมากเกินไป",
        (v) => v.length >= 2 || "* กรุณากรอกนามสกุลอย่างน้อย 2 ตัวอักษร",

        (v) => /^\S+(\s\S+)*$/.test(v) || "* กรุณากรอกข้อมูลให้ถูกต้อง",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      emailRules: [
        (v) => !!v || "* กรุณากรอกอีเมล",
        (v) => !/([ก-๏ ])/.test(v) || "* กรุณากรอกอีเมลให้ถูกต้อง",
        (v) => /.+@.+\.+/.test(v) || "* กรุณากรอกอีเมลให้ถูกต้อง",
        (v) => /.+@.+\.+([A-Za-z])+$/.test(v) || "* กรุณากรอกอีเมลให้ถูกต้อง",
        (v) => /.+@.+\.+/.test(v) || "* กรุณากรอกอีเมลให้ถูกต้อง",
        (v) => /.+@.+\.+([A-Za-z])+$/.test(v) || "* กรุณากรอกอีเมลให้ถูกต้อง",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      userRules: [
        (v) => !!v || "* กรุณากรอกชื่อผู้ใช้",
        (v) => v.length >= 4 || "* ชื่อผู้ใช้ควรมีความยาวอย่างน้อย 4 ตัว",
        (v) =>
          /^([A-Za-z0-9])+$/.test(v) ||
          "* กรุณาใส่ชื่อผู้ใช้งานเป็นภาษาอังกฤษหรือตัวเลข",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      passwordRules: [
        (v) => !!v || "* กรุณากรอกรหัสผ่าน",
        (v) => v.length >= 4 || "* รหัสผ่านควรมีความยาวอย่างน้อย 4 ตัว",
        (v) =>
          /^([A-Za-z0-9])+$/.test(v) ||
          "* กรุณาใส่รหัสผ่านเป็นภาษาอังกฤษหรือตัวเลข",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      cfpasswordRules: [
        (v) => !!v || "* กรุณายืนยันรหัสผ่าน",
        (v) => v == this.password || "* รหัสผ่านไม่ถูกต้อง",
      ],
    };
  },
  mounted() {
    this.$refs.form.resetValidation();
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  methods: {
    postData() {
      let prefix = "";
      if (this.radio == "mr") {
        prefix = "นาย";
      } else if (this.radio == "mrs") {
        prefix = "นาง";
      } else if (this.radio == "miss") {
        prefix = "นางสาว";
      } else if (this.radio == "etc") {
        prefix = this.etc_title;
      }
      let data = {
        title: prefix,
        firstname: this.firstname,
        lastname: this.lastname,
        username: this.username,
        password: this.password,
        email: this.email,
      };
      if (this.$refs.form.validate()) {
        this.axios
          .post(
            process.env.VUE_APP_API + "/api/v1/register",
            data,
            this.header_token
          )
          .then((response) => {
            // console.log(response.data);
            if (response.data == "create success") {
              this.$swal
                .fire("สร้างบัญชีผู้ใช้ใหม่สำเร็จ", "", "success")
                .then((result) => {
                  this.$router.push("/home");
                });
            } else if (
              response.data.message == "Does not exist this username"
            ) {
              this.$swal.fire(
                "username ถูกใช้ไปแล้ว",
                "กรุณาลองใหม่อีกครั้ง",
                "warning"
              );
            } else if (response.data.message == "Does not exist this email") {
              this.$swal.fire(
                "email ถูกใช้ ไปแล้ว",
                "กรุณาลองใหม่อีกครั้ง",
                "warning"
              );
              // this.$refs.for_loading.close();
            } else {
              this.$swal.fire("พบข้อผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "error");
            }
          });
      }
    },
  },
};
</script>